export default "__VITE_ASSET__DLVoat$6__"